// import api from '../config/api';
import moment from "moment";

const CONSTANTS = {
  ACTION: {
    VIEW: "view",
    EDIT: "edit",
    DELETE: "delete",
    ADD: "add",
    LIST: "list",
    QC: "qualitychecker",
    PRODUCT_TOPIC_ADD: "productTopic",
    SCRIPT_COMPLETED: "Completed",
    SCRIPT_SUBMITTED: "Submitted",
    PENDING: "Pending",
    REEDIT: "Re-Edit",
    COPY: "copy",
  },
  ENVIRONMENT_VAR: {
    LOCAL: "local",
    DEVELOPMENT: "development",
    STAGING: "staging",
    PRODUCTION: "production",
  },
  ROLE: {
    ADMIN: "SUPER_ADMIN",
    STUDIO_ADMIN: "STUDIO_ADMIN",
    STUDENT: "STUDENT",
    INSTRUCTOR: "INSTRUCTOR",
  },
  CONSTANTS_DATA: {
    CANCLE: "cancle",
    PENDING: "pending",
    COMPLETED: "completed",
    DEFAULT: "Default",
    INTERESTED: "Interested",
    ACCEPTED: "Accepted",
    REJECTED: "Rejected",
  },

  API_METHODS: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
  },
  STATUS: {
    OK: 200,
    CREATED: 201,
    REQUEST_FAILED: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    DATA_NOT_FOUND: 404,
    DUPLICATE_RECORD: 409,
    INTERNAL_SERVER_ERROR: 500,
    NOT_APPLICABLE: 406,
    // BAD_REQUEST: 400,
    UNPROCESSABLE_ENTITY: 422,
  },

  CURRENCY: [
    {
      id: "INR",
      key: "INR",
      name: "INR",
    },
    {
      id: "GBP",
      key: "GBP",
      name: "GBP",
    },
    {
      id: "EUR",
      key: "EUR",
      name: "EUR",
    },
    {
      id: "USD",
      key: "USD",
      name: "USD",
    },
  ],
  STYLES: {
    DEFAULT_BUTTON: "standardButton",
    DEFAULT_ENTRY: "standardEntry",
    COLOR: {
      BUTTON: {
        DARK_BUTTON: "standardDarkButton",
        LIGHT_BUTTON: "standardLightButton",
      },
    },
  },
};

export function dateTimeCheck(start_date, end_date, zone) {
  var currentTime = moment.utc();
  var startTime = new Date(
    moment.utc(start_date).subtract(45, "minutes").format("MM/DD/YYYY h:mm A")
  );
  var enddate = new Date(moment.utc(end_date).format("MM/DD/YYYY h:mm A"));
  var zoneid = new Date(
    moment()
      .tz(zone || moment.tz.guess())
      .format("MM/DD/YYYY h:mm A")
  );
  if (startTime === currentTime) {
    return true;
  } else {
    return false;
  }
  console.log(
    "dateTimeCheck00000000000",
    startTime,
    enddate,
    zoneid,
    startTime === currentTime
  );
}
export function CheckPastTime(date_time, end_date_time) {
  var currentTime = moment();
  var startTime = new Date(
    moment.utc(date_time).subtract(45, "minutes").format("MM/DD/YYYY h:mm A")
  );
  var endTime = new Date(moment.utc(end_date_time).format("MM/DD/YYYY h:mm A"));
  // console.log("moment------------------------",startTime,endTime)
  var amIBetween = currentTime.isBetween(startTime, endTime);
  // console.log(amIBetween);
  // var difference = startTime.getTime() - endTime.getTime(); // This will give difference in milliseconds
  // var resultInMinutes = Math.round(difference / 60000);
  return amIBetween;
}

export function CheckPastDate(date_time, zone) {
  // console.log("adasddate", date_time);

  // var date1 = new Date(moment.utc(value).format("MM/DD/YYYY h:mm A"));
  //   var date2 = new Date(moment().tz(this.state?.timezoneSelectedId || moment.tz.guess()).format('MM/DD/YYYY h:mm A'));

  // var startTime = new Date(moment.utc(date_time).format('MM/DD/YYYY h:mm A'));
  var startTime = new Date(moment.utc(date_time).format("MM/DD/YYYY h:mm A"));
  // var endTime = new Date();
  var endTime = new Date(
    moment()
      .tz(zone || moment.tz.guess())
      .format("MM/DD/YYYY h:mm A")
  );
  var difference = startTime.getTime() - endTime.getTime(); // This will give difference in milliseconds
  var resultInMinutes = Math.round(difference / 60000);
  // console.log("minutes----- new diff", resultInMinutes);
  // var now = new Date();
  // var then = date_time;
  // var diff = moment.duration(moment(then).diff(moment(now)));
  // var days = parseInt(diff.asDays()); //84
  // var hours = parseInt(diff.asHours()); //2039 hours, but it gives total hours in given miliseconds which is not expacted.
  // hours = hours - days * 24; // 23 hours
  // var minutes = parseInt(diff.asMinutes()); //122360 minutes,but it gives total minutes in given miliseconds which is not expacted.
  // minutes = minutes - (days * 24 * 60 + hours * 60);
  // console.log("minutes-----", minutes);
  return resultInMinutes;
}

export default CONSTANTS;
